import type { ProcurementRow } from './types'

const MATRIX_LABEL: Record<string, string> = {
  STOCK: 'Склад',
  CHINA: 'Китай',
  RF: 'РФ',
  MANUFACTURER: 'Произв.',
  OTHER: 'Другое',
}

export function ProcurementTable({
  procurement,
  onRowClick,
}: {
  procurement: ProcurementRow[]
  onRowClick?: (id: string) => void
}) {
  const top = [...procurement].sort((a, b) => b.quotesCount - a.quotesCount).slice(0, 5)

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm text-gray-500">
          Закупщики
          <span className="ml-2 text-xs text-gray-400">пришло → квот с ценой</span>
        </div>
        <span className="text-xs text-gray-400">Все {procurement.length}</span>
      </div>

      {top.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет данных за период</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-500">
              <th className="text-left font-normal pb-2">Имя</th>
              <th className="text-right font-normal pb-2">Пришло</th>
              <th className="text-right font-normal pb-2">Квот</th>
              <th className="text-right font-normal pb-2">Матрица</th>
            </tr>
          </thead>
          <tbody>
            {top.map((p) => (
              <tr
                key={p.id}
                onClick={() => onRowClick?.(p.id)}
                className={`border-t border-gray-100 ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
              >
                <td className="py-2 text-gray-900">{p.name}</td>
                <td className="py-2 text-right tabular-nums text-gray-600">{p.incomingCount}</td>
                <td className="py-2 text-right tabular-nums">{p.quotesCount}</td>
                <td className="py-2 text-right text-gray-600">
                  {p.primaryMatrix ? (MATRIX_LABEL[p.primaryMatrix] ?? p.primaryMatrix) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
